import { CommonGet, CommonPost } from "../../../utils/CommonFetch";
import tokenDecoder from '../../../components/Common/tokenDecoder';

export default {
    saveOperationCard,
    getAll,
    editData,
    getEstates,
    GetAllCollectionPoints,
    GetAllCollectionPointsCatagories,
    GetAllProducts,
    getOperationEntityByType,
    getAllOperationEntitiesForDropDown,
    getOperationCardsFilter,
    GetCollectionPointsFilter,
    getAllOperationCards,
    GetAllOperationEntityByGroupID
};

async function saveOperationCard(data) {
    let operationCard = {
        groupID: parseInt(data.groupID),
        operationEntityID: parseInt(data.operationEntityID),
        collectionPointID: parseInt(data.collectionPointID),
        collectionCatagoryID: parseInt(data.collectionCatagoryID),
        createdBy: parseInt(tokenDecoder.getUserIDFromToken()),
    }
    var List = await CommonGet('/api/OperationEntity/GetEntityTypeByOperationEntityIDandGroupID', 'operationEntityID=' + operationCard.operationEntityID + '&groupID=' + operationCard.groupID);
    var EntityTypeID = List.data;
    if (EntityTypeID == 2) {
        const response = await CommonPost('/api/Employee/EmployeeOperationCardCreation', null, operationCard);
        return response;
    } else {
        const response = await CommonPost('/api/Card/OperationCardCreation', null, operationCard);
        return response;
    }


}

async function getAll() {
    var operationCardList = await CommonGet('/api/Card/GetOperationCards', null);
    return operationCardList.data;
}

async function editData(data) {
    const response = await CommonPost('/api/CollectionPoint/UpdateOperationCards', null, data);
    return response;
}

async function getEstates() {
    var estateArray = []
    const response = await CommonGet('/api/Estate/GetAllEstates', null);
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true)
            estateArray[item[1]["estateID"]] = item[1]["estateName"]
    }
    return estateArray
}

async function GetAllCollectionPoints(id, collectionPointID) {
    const dataArray = [];
    const response = await CommonGet('/api/CollectionPoint/GetCollectionPointsForCommonOperationcard', 'operationEntityID=' + id + '&collectionPointID=' + collectionPointID);
    for (let item of Object.entries(response.data)) {
        dataArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"]
    }
    return dataArray;
}

async function GetAllCollectionPointsCatagories() {
    const opType = {
        1: "Route",
        2: "Division",
    }
    return opType;
}

async function GetAllProducts() {
    var productArray = [];
    const response = await CommonGet('/api/Product/GetProducts', null)
    for (let item of Object.entries(response.data)) {
        productArray[item[1]["productID"]] = item[1]["productName"]
    }
    return productArray;
}

async function getOperationEntityByType(type, groupID) {
    const dataArray = [];
    if (type === "1") {
        const response = await CommonGet('/api/OperationEntity/GetAllFactoriesByGroupID', 'groupID=' + groupID);
        for (let item of Object.entries(response.data)) {
            if (item[1]["isActive"] === true)
                dataArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
        }
    } else if (type === "2") {
        const response = await CommonGet('/api/OperationEntity/GetAllEstatesByGroupID', 'groupID=' + groupID);
        for (let item of Object.entries(response.data)) {
            if (item[1]["isActive"] === true)
                dataArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
        }
    }
    return dataArray;
}


async function GetAllOperationEntityByGroupID(groupID) {
    const response = await CommonGet('/api/OperationEntity/GetAllOperationEntityByGroupID', 'groupID=' + groupID);
    let array = []
    for (let item of Object.entries(response.data)) {
        if (item[1]) {
            array[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
        }
    }
    return array;
}


async function getAllOperationCards() {
    var operationCardList = await CommonGet('/api/Card/GetAllOperationCards', null);
    return operationCardList.data;
}

async function getAllOperationEntitiesForDropDown(id) {
    var operationEntityArray = [];
    var response = await CommonGet('/api/OperationEntity/GetAllOperationEntityByGroupID', 'groupID=' + id);
    for (let item of Object.entries(response.data)) {
        operationEntityArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"];
    }
    return operationEntityArray;
}

async function getOperationCardsFilter(data) {

    return CommonGet('/api/Card/GetCommonOperationCardsForListing', 'operationEntityID=' + data.operationEntityId + '&collectionPointID=' + data.collectionPointId)

}

async function GetCollectionPointsFilter(id) {
    var collectionPointArray = [];
    var response = await CommonGet('/api/CollectionPoint/GetAllActiveCollectionPointsByOperationEntityID', 'operationEntityID=' + id);
    for (let item of Object.entries(response.data)) {
        collectionPointArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"];
    }
    return collectionPointArray;
}